"use client";

import styles from "@/styles/modules/components/header/header.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useContext, useEffect } from "react";
import MainMenu from "./MainMenu";
import { MenuContext } from "@/context/menuContext";
import { Restaurant } from "@/types/wordpress";
import BlackOpacity from "./BlackOpacity";
import BookMenu from "./BookMenu";
import { BookMenuContext } from "@/context/bookMenuContext";
import { MenuItem } from "@/types/wordpress-parts";
import { translate } from "@/utils/translate";
import { usePathname } from "next/navigation";

import { useRouter } from "next/navigation";
import { LanguageContext } from "@/context/languageContext";
import { useLanguageUrl } from "@/context/languageURLContext";

interface HeaderProps {
  mainMenuEn: MenuItem[];
  mainMenuDe: MenuItem[];
  restaurants: Restaurant[];
}

export default function Header({
  mainMenuEn,
  mainMenuDe,
  restaurants,
}: HeaderProps) {
  const { openMenu } = useContext(MenuContext);
  const { openBookMenu } = useContext(BookMenuContext);
  const { language } = useContext(LanguageContext);

  const router = useRouter();
  const pathName = usePathname();

  const { url } = useLanguageUrl();

  return (
    <header className={styles.header}>
      <div className={styles.headerContainer}>
        <section className={styles.togglers}>
          <div className={styles.menu}>
            <Image
              src="/icons/hamburger-menu.svg"
              alt="Hamburger menu icon"
              width="41"
              height="31"
              onClick={openMenu}
            />
          </div>
          <Link
            href={url}
            className={`${styles.lang} ${language === "de" ? styles.toggled : ""}`}
          >
            <span>EN</span>
            <span>DE</span>
          </Link>
        </section>
        <section className={styles.logo}>
          <Link href={`${language === "en" ? "/en" : "/de"}`}>
            <Image
              src="/images/imperial-logo.svg"
              alt="Imperial Riding School logo"
              width="116"
              height="85"
              priority
            />
          </Link>
        </section>
        <section className={styles.links}>
          <div className={styles.button} onClick={openBookMenu}>
            <button>{translate["bookNow"][language]}</button>
          </div>
          <div className={styles.image}>
            <Link
              href={
                language === "en"
                  ? "https://autograph-hotels.marriott.com/"
                  : "https://autograph-hotels.marriott.com/de-DE/"
              }
              target="_blank"
            >
              <Image
                src="/images/autograph-logo.svg"
                alt="Autograph collection logo"
                width="100"
                height="24"
                priority
              />
            </Link>
          </div>
        </section>
        <MainMenu mainMenu={language === "en" ? mainMenuEn : mainMenuDe} />
        <BookMenu restaurants={restaurants} />
        <BlackOpacity />
      </div>
    </header>
  );
}
